import INITIAL_STATE from "./initialState";

const basketReducer = (state = [], action) => {
  switch (action.type) {
    case "ADD_ITEM": {
      const newState = [...state];
      newState.push(action.item);
      return newState;
    }
    case "SET_REQUEST": {
      const newState = [...state];
      const item = newState[action.index];
      if (item) {
        item.request = action.request ? action.request : "";
      }
      return newState;
    }
    case "INCREMENT_QUANTITY": {
      const newState = [...state];
      const item = newState[action.index];
      if (item) item.quantity = item.quantity + 1;
      return newState;
    }
    case "DECREMENT_QUANTITY": {
      const newState = [...state];
      const item = newState[action.index];
      if (item) {
        if (item.quantity <= 1) {
          newState.splice(action.index, 1);
          return newState;
        }
        item.quantity = item.quantity - 1;
      }
      return newState;
    }
    case "CLEAR":
      return INITIAL_STATE.basket;
    case "RESET_ORDER": {
      return action.payload.basket;
    }
    default:
      return state;
  }
};

const discountReducer = (state, action) => {
  switch (action.type) {
    case "ADD_DISCOUNT":
      return action.discount;
    case "CLEAR_DISCOUNT":
    case "CLEAR":
      return INITIAL_STATE.discount;
    case "RESET_ORDER":
      return action.payload.discount;
    default:
      return state;
  }
};

const noteReducer = (state, action) => {
  switch (action.type) {
    case "SET_NOTE":
      return action.note;
    case "CLEAR":
      return INITIAL_STATE.note;
    case "RESET_ORDER":
      return action.payload.note;
    default:
      return state;
  }
};

const orderAddressReducer = (state, action) => {
  switch (action.type) {
    case "SET_ORDER_ADDRESS":
      return action.address;
    case "CLEAR_ORDER_ADDRESS":
      return INITIAL_STATE.orderAddress;
    case "RESET_ORDER":
      return action.payload.orderAddress;
    default:
      return state;
  }
};

const orderTypeReducer = (state, action) => {
  switch (action.type) {
    case "SET_ORDER_TYPE":
      return action.orderType;
    case "CLEAR":
      return INITIAL_STATE.orderType;
    case "RESET_ORDER":
      return action.payload.orderType;
    default:
      return state;
  }
};

const paymentReducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_PAYMENT":
      return action.payment;
    case "CLEAR":
      return INITIAL_STATE.payment;
    case "RESET_ORDER":
      return action.payload.payment;
    default:
      return state;
  }
};

const transactionReducer = (state, action) => {
  switch (action.type) {
    case "ADD_TRANSACTION":
      return action.transaction;
    case "CLEAR":
      return INITIAL_STATE.transaction;
    case "RESET_ORDER":
      return action.payload.transaction;
    default:
      return state;
  }
};

const mainReducer = (
  { basket, discount, note, orderAddress, orderType, payment, transaction },
  action
) => ({
  basket: basketReducer(basket, action),
  discount: discountReducer(discount, action),
  note: noteReducer(note, action),
  orderAddress: orderAddressReducer(orderAddress, action),
  orderType: orderTypeReducer(orderType, action),
  payment: paymentReducer(payment, action),
  transaction: transactionReducer(transaction, action),
});
export default mainReducer;
